<template>
    <div>
        <b-col cols="12 mb-2 mt-3" v-if="items[0].indumentariasElegidas && items[0].indumentariasElegidas.length > 0">
            <b>Observaciones de las indumentarias:</b> {{ items[0].observacion_indumentarias }}
        </b-col>
        <div :class="items[0].activar_pago_plazos && plazos ? 'd-xl-flex justify-content-between align-items-center' : ''">
            <b-col cols="12" :md="items[0].activar_pago_plazos && plazos ? '6' : '12'" :xl="items[0].activar_pago_plazos && plazos ? '6' : '12'" class="table-responsive">
                <table class="table tabla-resumen table-bordered">
                    <tr class="lightgray-content">
                        <th></th>
                        <th>Pedido</th>
                        <th class="price">Precio</th>
                    </tr>

                    <template v-for="(elem, index) in items">
                        <tr :key="index">
                            <td class="h1 text-center regular">{{ ++index }}</td>
                            <td>
                                <strong class="text-bold h5 d-block mb-1">{{ elem.titulo }}</strong>
                                <template v-if="elem.descripcion">
                                    <strong class="text-bold h7 d-block mb-1">{{ elem.descripcion }}</strong>
                                </template>
                            </td>
                            <td>
                                <del v-if="items[0].activar_pago_plazos && plazos" class="h3 m-0">{{ elem.price_management_interno_online == 1 ? elem.precio : elem.precio + elem.price_management_online | formatear_precio }}</del>
                                <div v-else class="h3 m-0">{{ elem.price_management_interno_online == 1 ? elem.precio : elem.precio + elem.price_management_online | formatear_precio }}</div>
                            </td>
                        </tr>
                    </template>
                    <template v-if="items[0].indumentariasElegidas && items[0].indumentariasElegidas.length > 0">
                        <tr v-for="(indumentaria, index) in items[0].indumentariasElegidas" :key="index + '-' + indumentaria.id">
                            <td class="text-center"><img :src="indumentaria.imagen" style="width: 50px;" alt=""></td>
                            <td>
                                <strong class="text-bold h5 d-block mb-1">{{ indumentaria.nombre }} <small style="font-size: 11px;">({{ indumentaria.unidades + (indumentaria.unidades > 1 ? ' unidades' : ' unidad')}})</small></strong>
                                <small><strong class="text-bold h7 d-block mb-1">Talla {{ indumentaria.talla.nombre }}</strong></small>
                            </td>
                            <td>
                                <div class="h3 m-0" v-if="indumentaria.incluida && indumentaria.unidades == 1">{{ '0' | formatear_precio  }}</div>
                                <div class="h3 m-0" v-else>{{ indumentaria.precio_total | formatear_precio }}</div>
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="2" style="text-align: right">
                            <span class="total-price h2 m-0">{{ $t('bases.total') }}: </span>
                        </td>
                        <td>
                            <del v-if="items[0].activar_pago_plazos && plazos" class="total-price h2 m-0">{{ items[0].indumentariasElegidas ? totalConIndumentarias : total | formatear_precio }}<span>*</span></del>
                            <span v-else class="total-price h2 m-0">{{ items[0].indumentariasElegidas ? totalConIndumentarias : total | formatear_precio }}<small>*</small></span>
                        </td>
                    </tr>
                </table>
            </b-col>
            <b-col v-if="plazos && items[0].activar_pago_plazos" :class="!esMovil ? 'table-responsive mt-3' : 'table-responsive mt-5'" cols="12" :md="items[0].activar_pago_plazos && plazos ? '6' : '12'" :xl="items[0].activar_pago_plazos && plazos ? '6' : '12'">
                <table class="table tabla-resumen table-bordered">
                    <tr>
                        <th class="p-0 pt-1" colspan="3"><h3 class="text-center">{{ $t('bases.plazos') }}</h3></th>
                    </tr>
                    <tr class="lightgray-content">
                        <th></th>
                        <th>{{ $t('bases.fecha') }}</th>
                        <th>{{ $t('bases.importe') }}</th>
                    </tr>
                    <template v-for="(plazo, index) in plazos">
                        <tr :key="index">
                            <td class="pt-2 pb-0"><h5>{{ plazo.id }}</h5></td>
                            <td class="pt-2 pb-0"><h5>{{ plazo.fecha }}</h5></td>
                            <td class="pt-2 pb-0"><h5>{{ plazo.price_management_interno ? ($t('bases.importe_plazo', { importe_sin_gd: $n(plazo.importe, "currency"), gd: $n(plazo.price_management, "currency" ) })) : ($n(plazo.importe, "currency")) }}</h5></td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="2" style="text-align: right">
                            <span class="total-price h2 m-0">{{ $t('bases.total') }}: </span>
                        </td>
                        <td>
                            <span class="total-price h2 m-0">{{ totalPlazos | formatear_precio }}<small>*</small></span>
                        </td>
                    </tr>
                </table>
                <div v-if="items[0].activar_pago_plazos && plazos" class="border p-2">
                    <b><p class="m-0">{{ $t('bases.info_plazos') }}</p></b>
                </div>
            </b-col>
        </div>
        <b-col v-if="items[0].activar_pago_plazos" cols="12" class="mt-3 mb-3">
            <AddPlazosComponent
                :frecuencias="items[0].frecuencias_categorias"
                :min_plazos="items[0].min_cantidad_plazos"
                :max_plazos="items[0].max_cantidad_plazos"
                :gastos="items[0].price_management_online"
                :tiene_gastos="items[0].price_management_interno_online ? false : true"
                :disabled="!paso_activo"
                @terminado="calcularPlazos"
                @reset="pagarImporteCompleto"
            />
        </b-col>
        <b-col v-else>

        </b-col>
        <ResumenPrecioComponnent
            :price_management_interno="items[0].price_management_interno_online"
            :price_management="items[0].price_management_online"
            :price="priceResumen"
            :iva="footer.iva_base"
        />
        <div class="col-12 mt-4">
            <FormTerminos
                :error="error"
                :condiciones_plazos="footer.condiciones_bases_plazos"
                :texto_condiciones="texto_condiciones"
                :pago_plazos="items[0].activar_pago_plazos && plazos"
                :desactivar="!paso_activo"
                @continuar="aceptarCondiciones"
            />
        </div>
    </div>
</template>

<script>
import FormTerminos from '@/components/frontend/components/FormTerminos';
import ResumenPrecioComponnent from "@/components/frontend/compra/components/ResumenPrecioComponent.vue";
import AddPlazosComponent from '../compra/plazos/AddPlazosComponent.vue';

export default {
    props: ["items", "esMovil", "base", "paso_activo"],
    data() {
        return {
            error: false,
            plazos: null,
            texto_condiciones: `
                <p>1. Las cuotas indicadas en los plazos indicados se cobrarán automáticamente en la misma cuenta / Tarjeta que efectúa la primera cuota del plazo. No tendrá que realizar ningún movimiento.</p>
                <p>2. El incumplimiento de alguno de los plazos de pago podrá suponer la <b>invalidación de la ficha</b>.</p>
                <p>3. Podrá cancelar las cuotas indicadas desde su perfil abonando el importe de las mismas de manera individual o total.</p>
                <p>4. En caso de no realizar los pagos en los plazos indicados la organización podrá contactar con usted y ayudarle en lo posible.</p>
                <p>5. Una vez abonadas las cuantías económicas de los plazos indicados no permitirá solicitar la devolución del importe aunque el producto haya sido cancelado por incumplimiento de alguno de los plazos de pago.</p>
                <p>6. La organización podrá dar de baja la numeración de la ficha por incumplimiento de los plazos.</p>
                <p>7. La organización podrá solicitar el pago completo de la indumentaria en caso de no cumplir los plazos de pago en aquellas fichas donde la indumentaria esta incluida. En caso de no estar incluida y es un producto extra, podrá solicitar el pago completo de la indumentaria.</p>
                <p>8. Podrá saber la situación de cobros y fechas de cobro en su perfil.</p>
                <p>9. En caso de su tarjeta / Cuenta sufra alguna modificación deberá contactar con la organización.</p>
                <p>10. El coste del servicio corresponde a 0,96€ (iva incluido) por cada uno de los plazos de pago solicitados. </p>
            `
        };
    },
    computed: {
        total() {
            let total = 0;
            for (let i in this.items) {
                if(this.items[i].price_management_interno_online == 1) {
                    total = total + parseFloat(this.items[i].precio);
                } else {
                    total = total + (parseFloat(this.items[i].precio) + this.items[i].price_management_online);
                }
                
            }
            return total;
        },
        totalIndumentarias() {
            let total = 0;
            for (let i in this.items) {
                for (let j in this.items[i].indumentariasElegidas) {
                    if (this.items[i].indumentariasElegidas[j].incluida && this.items[i].indumentariasElegidas[j].unidades == 1) {
                        total = total + 0;
                    } else {
                        total = total + parseFloat(this.items[i].indumentariasElegidas[j].precio_total);
                    }
                }
            }
            return total;
        },
        totalPlazos() {
            let total = 0;
            
            if (this.plazos) {
                this.plazos.forEach(plazo => {
                    if (plazo.price_management_interno) {
                        total = total + plazo.importe + plazo.price_management;
                    } else {
                        total = total + plazo.importe;
                    }
                });
            }

            return total;
        },
        totalConIndumentarias() {
            return this.total + this.totalIndumentarias;
        },
        priceResumen() {
            let total = 0;

            if (this.plazos && this.plazos.length > 0) {
                total += this.plazos[0].importe;
            } else {
                if (this.items[0].indumentariasElegidas && this.items[0].indumentariasElegidas.length > 0) {
                    total += this.items[0].precio + this.totalIndumentarias;
                } else {
                    total += this.items[0].precio;
                }
            }

            return total;
        },
        footer() {
            return this.$store.getters.getFooter;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    methods: {
        calcularPlazos(data) {
            if (this.items[0].indumentariasElegidas && this.items[0].indumentariasElegidas.length > 0) {
                this.items[0].importe_total = this.items[0].price_management_interno_online == 0 ? this.totalConIndumentarias - this.items[0].price_management_online : this.totalConIndumentarias;
            }

            this.items[0].plazoSelect = data.plazoSelect;
            this.items[0].frecuenciaSelect = data.frecuenciaSelect;

            let params = {
                filters: {
                    tid: this.configuracion.hash_teatro
                },
                categoria: this.items[0]
            }
            this.$store.dispatch(this.config.getVuexAlias('front.bases.calcular-plazos'), params).then(res => {
                this.plazos = res.data.plazos;
            });

            this.closeModalPlazos('pago-plazos-bases');
        },
        aceptarCondiciones(continuar) {
            if (continuar == true) {
                this.$emit("isAccepted", true);
            } else {
                this.$emit("isAccepted", false);
            }
        },
        showModalPlazos(modal) {
            this.$modal.show(modal);
        },
        closeModalPlazos(modal) {
            this.$modal.hide(modal);
        },
        pagarImporteCompleto() {
            let params = {
                filters: {
                    tid: this.configuracion.hash_teatro
                },
                session_id: this.items[0].session_id
            }
            this.$store.dispatch(this.config.getVuexAlias('front.bases.borrar-plazos-carrito'), params).then(res => {
            });
            
            this.plazos = null;
            this.items[0].frecuenciaSelect = null;
            this.items[0].plazoSelect = null;
        }
    },
    components: { FormTerminos, ResumenPrecioComponnent, AddPlazosComponent },
};
</script>
